import { trpc } from '@/shared/api';

/** 랜딩 히어로 이미지 목록(어드민) — 노출 순서대로. */
export const useLandingHeroImagesQuery = () => trpc.landing.listHeroImagesAdmin.useQuery();
